export const categories = [
  {
    id: 1,
    name: '情感咨询',
    slug: 'emotional-consultation',
    description: '专业情感问题解析，帮您理清爱情中的困惑与迷茫',
    icon: 'ri-heart-line',
    color: 'bg-primary-500',
    image: 'https://readdy.ai/api/search-image?query=Warm%20couple%20talking%20in%20a%20cozy%20cafe%20with%20soft%20natural%20lighting%2C%20gentle%20expressions%2C%20emotional%20connection%2C%20warm%20beige%20and%20cream%20tones%2C%20editorial%20lifestyle%20photography%2C%20intimate%20atmosphere%2C%20soft%20bokeh%20background%2C%20comfortable%20seating%20with%20warm%20textures&width=800&height=600&seq=cat-emotion-01&orientation=landscape',
  },
  {
    id: 2,
    name: '两性健康',
    slug: 'sexual-health',
    description: '科学专业的两性健康知识，守护您和伴侣的身心健康',
    icon: 'ri-shield-check-line',
    color: 'bg-accent-500',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20wellness%20scene%20with%20soft%20pastel%20candles%20and%20fresh%20flowers%20on%20a%20minimal%20wooden%20table%2C%20warm%20natural%20light%2C%20serene%20and%20peaceful%20atmosphere%2C%20spa-like%20aesthetic%2C%20cream%20and%20sage%20green%20tones%2C%20lifestyle%20photography&width=800&height=600&seq=cat-health-02&orientation=landscape',
  },
  {
    id: 3,
    name: '伴侣沟通',
    slug: 'partner-communication',
    description: '掌握高效沟通技巧，让每一次对话都成为增进感情的契机',
    icon: 'ri-chat-1-line',
    color: 'bg-secondary-500',
    image: 'https://readdy.ai/api/search-image?query=Two%20people%20sitting%20on%20a%20park%20bench%20engaged%20in%20deep%20conversation%2C%20autumn%20leaves%20in%20warm%20golden%20light%2C%20genuine%20eye%20contact%2C%20comfortable%20body%20language%2C%20warm%20amber%20and%20terracotta%20tones%2C%20cinematic%20lifestyle%20photography&width=800&height=600&seq=cat-comm-03&orientation=landscape',
  },
  {
    id: 4,
    name: '亲密关系',
    slug: 'intimacy-relationship',
    description: '深度探索亲密关系的艺术，建立持久而美好的情感连接',
    icon: 'ri-heart-pulse-line',
    color: 'bg-primary-500',
    image: 'https://readdy.ai/api/search-image?query=Couple%20holding%20hands%20walking%20on%20a%20quiet%20beach%20at%20sunset%2C%20soft%20golden%20hour%20light%2C%20gentle%20waves%2C%20warm%20and%20romantic%20atmosphere%2C%20intimate%20moment%2C%20cream%20and%20coral%20tones%2C%20fine%20art%20photography&width=800&height=600&seq=cat-intimacy-04&orientation=landscape',
  },
  {
    id: 5,
    name: '自我成长',
    slug: 'self-growth',
    description: '在爱中遇见更好的自己，个人成长与情感智慧的全面提升',
    icon: 'ri-plant-line',
    color: 'bg-accent-500',
    image: 'https://readdy.ai/api/search-image?query=Person%20reading%20a%20book%20in%20a%20sunlit%20room%20with%20plants%2C%20morning%20light%20streaming%20through%20windows%2C%20peaceful%20and%20contemplative%20mood%2C%20minimal%20interior%20design%2C%20warm%20beige%20and%20soft%20green%20tones%2C%20lifestyle%20photography&width=800&height=600&seq=cat-growth-05&orientation=landscape',
  },
];